import {
	FETCH_AVAILABLE_NUMBER_LIST,
	IS_LOADING,
    FETCH_PAGINATED_LIST,
    RESET_TOTAL,
} from '../actions/subscribeNumber.action';
import { SubscribeNumberReducer } from '../models/subscribeNumber.interface';

const initialState: SubscribeNumberReducer = {
	isLoading: false,
	isError: false,
	errorMessage: '',
	availableNumberList: [],
	totalNumbers: -1,
	balance: 0,
	currency: '',
	countryIsoCode: '',
    countryDialCode: '',
    firstSubscription: 0,
	activationDetails: '',
	exchangeRate: 1,
};

const subscribeNumberReducer = (
	state: SubscribeNumberReducer = initialState,
	action: any
): SubscribeNumberReducer => {
	switch (action.type) {
		case IS_LOADING:
			return {
				...state,
				isLoading: action.payload,
			};
		case FETCH_PAGINATED_LIST:
			return {
				...state,
				availableNumberList: [
					...state.availableNumberList,
					...action.payload.res,
				],
				totalNumbers: action.payload.total,
				balance: action.payload.balance,
				currency: action.payload.currency,
				countryIsoCode: action.payload.countryIsoCode,
				countryDialCode: action.payload.countryDialCode,
				isError: false,
				exchangeRate:action.payload.exchangeRate,
			};
		case FETCH_AVAILABLE_NUMBER_LIST:
			return {
				...state,
				availableNumberList: action.payload.res,
				totalNumbers: action.payload.total,
				balance: action.payload.balance,
				currency: action.payload.currency,
				countryIsoCode: action.payload.countryIsoCode,
				countryDialCode: action.payload.countryDialCode,
				isError: false,
				exchangeRate:action.payload.exchangeRate,
            };
        case RESET_TOTAL:
            return {
                ...state,
                totalNumbers: -1,
            };
		default:
			return state;
	}
};

export default subscribeNumberReducer;
